import { InjectionToken } from '@angular/core';

export const PERSISTED_STORAGE_KEYS = new InjectionToken<string[]>('Persisted storage keys');
